<script setup lang="ts">
import {useElementor, useSeo, useWp} from "../../composables/Redmonkey/index";
import PollForm from "~/components/Redmonkey/PollForm.vue";
import type {MetaInfo} from "@intlify/core-base";
const {$config} = useNuxtApp();

const Elementor = defineAsyncComponent(() => import('~/components/Redmonkey/Elementor/Elementor.vue'))

const {path} = useRoute();
const pageStore = usePageStore();
const {getElementor} = useElementor();
const {getSeo} = useSeo();

const {setLoading} = useWp();

const urlFixer = (url: string) => {
  if (url[0] === '/') {
    url = url.substring(1);
  }

  if (url[url.length - 1] === '/') {
    url = url.slice(0, -1);
  }

  return url;
}

const getData = async () => {
  setLoading(true);
  const fetchUrl = async (routePath = path) => {
    const clearUrl = routePath.replace(/[a-z]+\/[cp|]\//gi, '');

    const currentUrl = (clearUrl === '/' || clearUrl === '') ? '/' : urlFixer(clearUrl);

    const {data: page} = await useFetch('/api/wordpress/getPageByUrl', {
      method: "post",
      body: {url: currentUrl}
    });

    const {pageBy} = page.value;

    if (pageStore.routeData !== pageBy) {
      pageStore.$patch((state) => {
        state.routeData = pageBy;
      });
    }

    setTimeout(() => {
      setLoading(false);
    }, 200)

    return pageBy;
  }

  return await fetchUrl();
}

const page = ref(await getData());

if (page.value === null) {
  navigateTo('/no_route');
}

const meta = getSeo(page.value) as MetaInfo;

meta.link = [
  {
    rel: 'stylesheet',
    href: `${$config.public.wpContentPlugins}elementor/assets/css/frontend-lite.min.css`,
    id: 'elementor-frontend-css',
    hid: 'elementor-frontend-css',
  },
  {
    rel: 'stylesheet',
    href: `${$config.public.wpContentUploads}elementor/css/global.css`,
    id: 'elementor-global-css',
    hid: 'elementor-global-css',
  },
  {
    rel: 'stylesheet',
    href: `${$config.public.wpContentUploads}elementor/css/post-7.css`,
    id: `elementor-post-7-css`,
    hid: `elementor-post-7-css`
  },
];

useHead(meta);

const elementorContent = computed(() => getElementor(page.value));

const isPollFormEnable = () => {
  return page.value?.pollForm?.enable && page.value?.pollForm?.form;
}
</script>

<template>
  <div class="page">
    <div v-if="page">
      <div class="elementor" v-if="elementorContent">
        <Elementor :elementor="elementorContent"/>
      </div>
      <div class="content" v-else-if="page.content" v-html="page.content"/>
    </div>
    <PollForm v-if="isPollFormEnable()" :data="page.pollForm"/>
  </div>
</template>